<template>
  <v-container id="users" class="py-0" fluid>
    <v-skeleton-loader :loading="loading" transition-group="scale-transition" type="card-avatar, article, actions">
      <v-row>
        <v-col cols="12" xl="3" lg="3" md="4" sm="6" xs="12" v-for="user in users" :key="user.id">
          <v-card class="mx-auto">
            <v-avatar tile color="grey lighten-2" height="150px" width="100%"><v-icon color="grey" x-large>mdi-account-box</v-icon></v-avatar>
            <v-card-title>{{ user.name }} {{ user.surname }}</v-card-title>
            <v-card-subtitle>{{ user.username }}</v-card-subtitle>
            <v-card-actions>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="orange" v-on="on" @click="edit(user)"><v-icon>mdi-circle-edit-outline</v-icon></v-btn>
                </template>
                <span>Modifica utente</span>
              </v-tooltip>
              <v-spacer></v-spacer>
              <v-tooltip bottom v-if="user.isAdministrator">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="grey" v-on="on"><v-icon>mdi-star</v-icon></v-btn>
                </template>
                <span>Amministratore</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="grey" v-on="on"><v-icon>mdi-account</v-icon></v-btn>
                </template>
                <span>Operatore</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-skeleton-loader>

    <user-form ref="refUserForm" :user="selectedUser" @saved="notify"></user-form>
    <notify ref="refNotify"></notify>
  </v-container>
</template>

<script>
import NotifyVue from '../dialog/Notify.vue';
import apiRepository from '../../api/api-repository';
import UserFormVue from './UserForm.vue';

export default {
  name: 'UserView',

  components: {
    'user-form': UserFormVue, // form di modifica dell'utente.
    'notify': NotifyVue, // componente per la visualizzazione degli errori in snackbars.
  },

  data: ()=> ({
    loading: true, // flag per lo skeleton loader.
    users: new Array(), // lista degli utenti attivi.
    selectedUser: new Object(),
  }),

  methods: {
    async load(){
      try{
        let res = await apiRepository.users().findAll(); // attendo il risultato della chiamata.
        this.users = res.data; // carico il risultato sulla lista degli utenti.
        this.loading = false; // disabilito lo skeleton loader.
      }
      catch(e){
        console.error('exception:', e); // loggo l'errore riscontrato.
        this.$refs.refNotify.notify('error', e.message); // notifico l'errore riscontrato nell'operazione.
      }
    },

    edit(user){
      this.selectedUser = user;
      this.$refs.refUserForm.open();
    },

    notify(res){
      this.load();
      if(res.success) this.$refs.refNotify.notify('success', res.message);
      else this.$refs.refNotify.notify('error', res.message);
    }
  },

  mounted(){
    this.load();
  }
}
</script>